import React, { useEffect, useState, useContext } from 'react'
import { Row, Container, Col } from 'react-bootstrap'
import $ from "jquery";

import CustomSpinner from '../generic/CustomSpinner';

import { ModalContext } from "../../context/modalContext";
import { ConfirmModalContext } from "../../context/confirmModalContext";

import { Accordion, Card, Button } from 'react-bootstrap';
import ComponentTable from '../generic/ComponentsTable';
import AddDestinoLaico from './formularios/AddDestinoLaico';
import Icon from '../generic/Icon';
import { AlertBoxContext } from "../../context/alertBoxContext";


// Images
import deleteIcon from "../../assets/delete.png";
import editIcon from "../../assets/editing.png";

const DestinoLaico = ({ esMonja, userId, datosUsuario, accessLevel, ...props }) => {
    //console.log(esMonja)
   // console.log(userId)
    //console.log(datosUsuario)
    // Spinner
    const [loading, setLoading] = useState(false);
    const [destinosLaico, setDestinosLaico] = useState({})
    const [provincias, setProvincias] = useState({})
    // Contexto
    const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
    // Alertas
    const { addAlert } = useContext(AlertBoxContext);


    // Ventana de confirmación
    const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

    useEffect(() => {
        handleObtenerDestinosLaico()
        handleObtenerProvincias()
    }, [])

    const obtenerProvincias = () => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/provincias?ended=false&dg=d`,
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleObtenerProvincias = () =>{
        setLoading(true);
        obtenerProvincias()
        .then((response) => {
            setProvincias(response);
            setLoading(false);
        })
        .catch((e) => {
            //console.log(e)
            setLoading(false);
        });
    }
//leer destinos
    const obtenerDestinoLaico = () => {
        //console.log(`${process.env.REACT_APP_API_URL}/usuarios/${userId}/destinolaico`)
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/destinolaico`,
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleObtenerDestinosLaico = () => {
        setLoading(true);
        obtenerDestinoLaico()
            .then((response) => {
                setDestinosLaico(response);
                setLoading(false);
            })
            .catch((e) => {
                //console.log(e)
                setLoading(false);
            });
    }
//eliminar destino
    const deleteDestinoLaico = (data) => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/destinolaico/${data}`,
            method: "DELETE",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleDeleteDestinoLaico = (data) => {
        setLoading(true);
        //console.log(data)
        deleteDestinoLaico(data.id)
            .then(() => {
                addAlert("Exito", `Se ha eliminado el destino correctamente`, "success");
                handleObtenerDestinosLaico()
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                addAlert("Error", `No se ha podido eliminar el destino`, "danger");
            });
    }
//POST destino
const handlePostDestinoLaico = (data) => {
    // console.log(`${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}`)
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/destinolaico`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  //PUT destino
  const handlePutDestinoLaico = (data) => {
    // console.log(`${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}`)
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/destinolaico/${data.id}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  const handleForm = (datum, post) => {
     modalSetShow(false);
    setLoading(true);
    if (post){
        handlePostDestinoLaico(datum)
        .then(() => {
            setLoading(false);
            handleObtenerDestinosLaico()
            addAlert("Éxito", "Se ha añadido el destino correctamente", "success");
          })
          .catch(() => {
            setLoading(false);
            addAlert("Error", "Error al agregar el destino. Verifique los datos", "danger");
          });
    }else{
        handlePutDestinoLaico(datum)
        .then(() => {
            setLoading(false);
            handleObtenerDestinosLaico()
            addAlert("Éxito", "Se ha actualizado el destino correctamente", "success");
          })
          .catch(() => {
            setLoading(false);
            addAlert("Error", "Error al actualizar el destino. Verifique los datos", "danger");
          });
    }
    
      
  }

    const procesaFechaInicio = (row) => {
        return row?.startDate ? `${row.startDate}` : '';
    }
    const procesaFechaFin = (row) => {
        return row?.endDate ? `${row.endDate}` : 'no definida';
    }
    const procesaProvincia = (row) => {
        return row?.province?.name;
    }

    // Gestiona la acción que se realiza cuando damos en la imagen de editar cargo
    const editTupla = (row) => {
        return (
            <Icon
                src={editIcon}
                onClick={() => {
                    modalSetShow(true, "80%");
                    modalSetTitle(`Editar destino de usuario`);
                    modalSetContent(<AddDestinoLaico provincias={provincias} handleForm={handleForm} edicion={row} />);
                }}
                className="d-flex m-auto"
            />
        );

    };

    // Gestiona la acción que se realiza cuando damos en la imagen de eliminar cargo
    const deleteTupla = (row) => {
        return (
            <Icon
                src={deleteIcon}
                onClick={() => {

                    confirmModalSetTitle(`Eliminar destino del laico`)
                    confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el destino del usuario?`} </p>)
                    confirmModalSetFunction(() => {
                        handleDeleteDestinoLaico(row)
                    })
                    confirmModalSetShow(true)

                }}
                className="d-flex m-auto"
            />
        );
    };

    return (
        <>
            <div style={{ position: "relative" }}>
                <CustomSpinner animation={"border"} loading={loading} />
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle eventKey="0" as={Button} variant="link">
                                Destinos en la Congregación STJ
                            </Accordion.Toggle>
                            {accessLevel >= 8 && (
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="float-right mr-4"
                                    onClick={() => {
                                        modalSetShow(true, "60%");
                                        modalSetTitle("Añadir destino para el laico en la Congregación");
                                        modalSetContent(<AddDestinoLaico provincias={provincias} handleForm={handleForm} />);
                                    }}
                                >
                                    Añadir
                                </Button>
                            )}
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <p>
                                    <small>(Ordenado de más reciente a más antiguo)</small>
                                </p>

                                {destinosLaico.length ? <ComponentTable
                                    emptyTableComponent={<p className="m-2">{`No hay destinos para este usuario`}</p>}
                                    headers={[
                                        { name: "Fecha de inicio", value: procesaFechaInicio },
                                        { name: "Fecha de fin", value: procesaFechaFin },
                                        { name: "Provincia", value: procesaProvincia },
                                        { name: "Editar", value: editTupla },
                                        { name: "Eliminar", value: deleteTupla },
                                    ]}
                                    rows={destinosLaico}
                                />
                                    : (
                                        <p>No hay destinos para este usuario</p>
                                    )}
                                {/*   {cursos.length ? (
                cursos.map((situacion) => {
                  return <SituacionParticular accessLevel={accessLevel} key={situacion.id} situacionParticular={situacion} deleteSituacionParticularState={deleteSituacionParticular} />;
                })
              ) : (
                <p>No hay situaciones particulares actualmente.</p>
              )}*/}

                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        </>
    )
}

export default DestinoLaico